import { MATCH_ATTENDEE, MATCH_MEETING } from 'constants/meetings'
import { SchedulingMethods, Statuses } from 'services/search_api/constants'

export const Periods = Object.freeze({
  UPCOMING: 'upcoming',
  PAST: 'past',
  FIXED: 'fixed',
  THIS_WEEK: 'this_week',
  THIS_MONTH: 'this_month',
  THIS_YEAR: 'this_year',
  TODAY: 'today',
  ALL_TIME: 'all_time'
})

// Size-based breakpoints for UiConfig - automatically generates named queries
// like isSmallPhone, isPhone, isTabletUp, isDesktopUp for use with useDeviceType()
export const MEETING_CARD_BREAKPOINTS = {
  small: 400,
  medium: 800,
  large: 1100,
  xLarge: 1500
}

export const WEB_APP_HEADER_HEIGHT = 72
export const WEB_APP_FOOTER_PADDING = 40
export const ADDITIONAL_PADDING = 70
export const CARD_WIDTH = 267
export const CARD_HEIGHT = 287
export const LIST_HEIGHT = 116

export const LOADING_HEIGHT = 40

export const nonHostValue = 'non_host'

export const canceledValue = 'canceled'

export const allValue = 'all'

const hostValue = 'host'

export const defaultFilterParams = {
  period: Periods.PAST,
  status_ids: [Statuses.ACTIVE],
  scheduling_methods: [SchedulingMethods.CALENDLY],
  event_type_ids: [],
  host_ids: [hostValue],
  meeting_intelligence_status: Statuses.COMPLETED,
  invitee_emails: [],
  team_ids: [],
  user_ids: [],
  utm_campaign: [],
  utm_content: [],
  utm_medium: [],
  utm_source: [],
  utm_term: []
}

export const recapFilters = {
  past: true,
  role: ['HOST'],
  searchIn: [MATCH_ATTENDEE, MATCH_MEETING],
  meetingIntelligenceStatus: 'COMPLETED'
}

export const MAX_FETCH_RECAP_STATUSES_BATCH_SIZE = 25

export const RecapPermission = Object.freeze({
  OWNER: 'OWNER',
  SHARE: 'SHARE',
  VIEW: 'VIEW',
})

// SpiceDB relations
export const RecapPermissionRelation = Object.freeze({
  SHARE: 'sharer',
  VIEW: 'viewer',
  ORGANIZATION: 'organization',
})

export const RECAP_SHARING_ACCESS_FLAG = 'recap_sharing_access'

export const RECAP_ACCESS_LEVELS = Object.freeze({
  PRIVATE: 'Private',
  RESTRICTED: 'Restricted',
  PUBLIC: 'Public',
  PASSCODE: 'Passcode', // Soon to be deprecated
})

export const RECAP_PERMISSION_RELATIONS = Object.freeze({
  OWNER: 'owner',
  VIEWER: 'viewer',
  SHARER: 'sharer',
})

export const isRecapPublic = (accessLevel) => accessLevel === RECAP_ACCESS_LEVELS.PUBLIC || accessLevel === RECAP_ACCESS_LEVELS.PASSCODE

export const normalizeRecapAccessLevel = (accessLevel) => {
  if (!accessLevel) {
    return RECAP_ACCESS_LEVELS.PRIVATE
  }

  if (isRecapPublic(accessLevel)) {
    return RECAP_ACCESS_LEVELS.PUBLIC
  }

  return accessLevel
}
